export default "__VITE_ASSET__BHeK2f_l__"